<div class="device-details">
    <base-node [node]="node">
        <div class="full-height full-width">

            <div *ngIf="(hasData$ | async) === undefined" class="container centered-content spinner-content">
                <mat-spinner strokeWidth="3" [diameter]="50"></mat-spinner>
            </div>

            <ng-container *ngIf="(hasData$ | async) === true">
                <psd-chart *ngIf="chartData$ | async as chartData"
                    class="full-height"
                    [data]="[chartData]"
                    [showLegends]="false"
                    [fontSize]="'0.5rem'">
                </psd-chart>
            </ng-container>

            <ng-container *ngIf="(hasData$ | async) === false">
                <div class="container centered-content">
                    <mat-icon svgIcon="empty-data" class="not-found-svg"></mat-icon>
                    <div>No Data Found</div>
                </div>
            </ng-container>

        </div>
    </base-node>
</div>